
/// <amd-module name="Repos/Views/Settings/Repositories/Components/RepositoriesChecksComponent" />
import * as React from "react";
import { IRepositoriesViewService } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { WrappedComponent } from "VSS/Platform/Layout";

export interface IProps {
    repositoryId: string;
    resourceName: string;
    hasManagePermission: boolean;
}

export interface IState {
    dataInitialized: boolean;
}

export class RepositoriesChecksComponent extends VssComponent<IProps, IState> {

    constructor(props: IProps, context: IVssComponentContext) {
        super(props, context);
        this._pageContext = context.pageContext;
        this.state = { dataInitialized: false };
    }

    public componentDidMount() {
        const viewService = this._pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
        viewService.getPipelinesChecksData(this.props.repositoryId).then(() => {
            if (this._isMounted) {
                this.setState({ dataInitialized: true });
            }
        }, (error) => {
        });
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        if (this.state.dataInitialized) {
            return (
                <WrappedComponent 
                    dependencies={["ms.vss-pipelinechecks.web"]}
                    wrappedProps={{
                        resourceId: this.props.repositoryId,
                        resourceType: "repository",
                        resourceName: this.props.resourceName,
                        hasManagePermission: true,
                        dataProviderRequestParameters:{ "repositoryId": this.props.repositoryId },
                        className: "no-padding"
                    }}
                    wrappedType="checks-overview-component"/>
            );
        }
        return null;
    }

    private _pageContext: IVssPageContext;
    private _isMounted: boolean = true;
}
